import api from '@/api';
import moment from 'moment';

const state = {
  projectsBugs: [],
  usersBugs: [],
  loadedProject: null,
  loadedUser: null,
};

const getters = {
  projectBugs: state => state.projectsBugs
    .find(project => project.projectName === state.loadedProject),
};

const actions = {
  async getListByProject({ state, commit, rootGetters }, payload) {
    if (state.loadedUser === payload.user && state.projectsBugs.length > 0) {
      return;
    }

    commit('projectsBugs', []);
    commit('loadedUser', payload.user);
    const user = rootGetters['users/getUserById'](state.loadedUser);
    const response = await api.post('Bugs/List', {
      Member: user,
      StartDate: payload.startDate,
      EndDate: payload.endDate,
    });

    commit('projectsBugs', response.data.projectBugs);
  },

  async exportToExcel({ state, rootGetters }) {
    const user = rootGetters['users/getUserById'](state.loadedUser);
    const response = await api.post('Reports/ExportBugtReportToExcel', {
      projectBugs: state.projectsBugs,
      name: state.loadedUser,
    }, { responseType: 'blob' });

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `Bugs_${user.user.displayName}_${moment().format('YYYY-MM-DD')}.xlsx`);
    document.body.appendChild(link);
    link.click();
  },

  async getAllBug({ commit, rootState }, payload) {
    const response = await api.post('Bugs/All', {
      StartDate: payload.startDate,
      EndDate: payload.endDate,
      Users: rootState.users.users,
    });

    commit('usersBugs', response.data);
  },
};

const mutations = {
  projectsBugs(state, payload) {
    state.projectsBugs = payload;
  },
  usersBugs(state, payload) {
    state.usersBugs = payload;
  },
  loadedUser(state, payload) {
    state.loadedUser = payload;
  },
  loadedProject(state, payload) {
    state.loadedProject = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
